import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { DOWNLOADABLES_ERROR, GET_DOWNLOADABLES, GETTING_DOWNLOADABLES } from "../types"

export const fetchDownloadables = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/downloadables?expand=createdBy&accessType=PARENTS`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_DOWNLOADABLES,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_DOWNLOADABLES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}